
import { useEffect, useState } from "react";
// @ts-ignore - Import the built version directly to avoid "path.join" issues in Vite
import kuromoji from "kuromoji/build/kuromoji";

// Define the token type based on kuromoji's output
export interface KuromojiToken {
  word_id: number;
  word_type: "KNOWN" | "UNKNOWN";
  word_position: number;
  surface_form: string;
  pos: string;
  pos_detail_1: string;
  pos_detail_2: string;
  pos_detail_3: string;
  conjugated_type: string;
  conjugated_form: string;
  basic_form: string;
  reading?: string;
  pronunciation?: string;
}

export type Tokenizer = {
  tokenize: (text: string) => KuromojiToken[];
};

// Singleton promise to ensure tokenizer is only loaded once
let tokenizerPromise: Promise<Tokenizer> | null = null;

export function useKuromoji() {
  const [tokenizer, setTokenizer] = useState<Tokenizer | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // If already loaded in state, do nothing
    if (tokenizer) {
      setLoading(false);
      return;
    }

    // Initialize promise if not exists
    if (!tokenizerPromise) {
      // Use absolute path to avoid relative path issues in nested routes
      const dicPath = "/dict/"; 
      
      tokenizerPromise = new Promise((resolve, reject) => {
        // @ts-ignore
        kuromoji.builder({ dicPath }).build((err, _tokenizer) => {
          if (err) {
            console.error("Kuromoji initialization failed:", err);
            reject(err);
          } else {
            resolve(_tokenizer);
          }
        });
      });
    }

    // Wait for promise
    let mounted = true;
    tokenizerPromise
      .then((_tokenizer) => {
        if (mounted) {
          setTokenizer(_tokenizer);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (mounted) {
          console.error("Kuromoji load error in hook:", err);
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [tokenizer]);

  return { tokenizer, loading, error };
}
